module.exports = __webpack_public_path__ + "img/arb_approve_logo.635b0496.png";